// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__kxVIP","footer_text":"footer_footer_text__uMTmU","footer_links":"footer_footer_links__Cqgnk","dashboard-footer":"footer_dashboard-footer__+9azB"};